const YOUTUBE_ID_REGEX =
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([\w-]{11})/;

/**
 * Extracts the 11-character video ID from various YouTube URL formats.
 * Supports: watch?v=, youtu.be/, /embed/, /shorts/.
 * Returns null if the URL is not a YouTube link.
 */
export const getYouTubeId = (url?: string): string | null => {
    if (!url) return null;
    const match = url.match(YOUTUBE_ID_REGEX);
    return match?.[1] ?? null;
};
